module.exports = __webpack_public_path__ + "img/wenti2.648921ce.png";